<template>
    <div class="fun-fact">
          <!-- <em>Quick Bytes:</em> -->
          <p>&nbsp;</p>
    </div>
</template>

<script>
export default {
    name: 'FunFacts',
    async mounted() {
        let facts = [
        'i started programming when I was <em>seven</em>.',
        'i made my first game in <em>notepad</em> with batch.',
        'i daily-drive <em>arch</em> btw.',
        'i play the <em>guitar</em>!',
        'my first game engine was <em>Unity</em>.',
        'i used to make <em>music</em> with GarageBand loops.',
        'i used to make Minecraft <em>animations</em> with Blender.',
        'i\'ve been featured on <em>Squared Media</em> for my animations!',
        'i have remade the <em>same</em> FPS game about <em>24</em> times :p',
        'i also play the <em>piano</em>.',
        ]
        let i = 0
        for(;;) {
            if (i >= facts.length) { i = 0 }
            this.$el.children[0].innerHTML = facts[i]
            this.$el.classList.add("visible")
            i++
            await new Promise(r => setTimeout(r, i === 1 ? 3000 : 12000)) // shorter on first
            this.$el.classList.remove("visible")
            await new Promise(r => setTimeout(r, 6000))
        }
    }
}
</script>
<style scoped>
:deep()p{margin: 0}
</style>